import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/app/store";

export const selectStory = (state: RootState) => state.story;
export const selectStoryModeMissionStatus = (state: RootState) =>
  state.story.storyModeMissionStatus;
export const selectStoryModeProgress = (state: RootState) =>
  state.story.storyModeProgress;
export const selectStoryModeLeaderboard = createSelector(
  [
    (state: RootState) => state.story.storyModeLeaderboard,
    (state: RootState) => state.story.isLoadingStoryModeLeaderboard,
  ],
  (entries, isLoading) => ({ entries, isLoading })
);

export const selectWeeklyMissions = (state: RootState) => state.weeklyMissions;
export const selectWeeklyMissionSummary = createSelector(
  [
    (state: RootState) => state.weeklyMissions.weeklyMissionStatus,
    (state: RootState) => state.weeklyMissions.weeklyMissionProgress,
  ],
  (status, progress) => ({ status, progress })
);
export const selectWeeklyLeaderboard = createSelector(
  [
    (state: RootState) => state.weeklyMissions.weeklyLeaderboard,
    (state: RootState) => state.weeklyMissions.isLoadingWeeklyLeaderboard,
  ],
  (entries, isLoading) => ({ entries, isLoading })
);
export const selectWeeklyTotalRewardLeaderboard = createSelector(
  [
    (state: RootState) => state.weeklyMissions.weeklyLeaderboardTotalReward,
    (state: RootState) =>
      state.weeklyMissions.isLoadingWeeklyLeaderboardTotalReward,
  ],
  (entries, isLoading) => ({ entries, isLoading })
);
